// Utility functions for performance optimization

type AnyFunction = (...args: unknown[]) => void;

export const debounce = (func: AnyFunction, wait: number): AnyFunction => {
  let timeout: ReturnType<typeof setTimeout>;
  return function executedFunction(...args: unknown[]) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

export const throttle = (func: AnyFunction, limit: number): AnyFunction => {
  let inThrottle = false;
  return function executedFunction(...args: unknown[]) {
    if (!inThrottle) {
      func(...args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), limit);
    }
  };
};

